import Logo from "../../../assets/images/header/logo.svg";
import Texas from "../../../assets/images/events/tx.svg";
import EventsStyles from "../Events.module.css";
import DallasAgenda from "../../../assets/images/DallasAgenda-2026.pdf";

const TexasImg = EventsStyles.TexasImg;

const DallasAgendaOpen = () => {
  window.open(DallasAgenda);
};

// coming soon message for pending agenda
const msgTexas = () => {
  alert("Dallas Texas Agenda is Coming Soon");
};

const agenda = () => {
  window.open("/agendas");
};

const EventsData = [
  // {
  //   id: 0,
  //   logo: Logo,
  //   state: Michigan,
  //   classNameState: MichiganImg,
  //   stateName: "Grand Rapids, Michigan",
  //   stateSubName: "Round Up 2024",
  //   when: " Jul 26, 2024 – Jul 28, 2024",
  //   time: " 7:00 PM",
  //   addressTitle1: "EVENT HAS PAST",
  //   addressTitle2: "",
  //   address1: "",
  //   address2: "",
  //   btnTittle: "REGISTER",
  //   btnTittle2: "VIEW AGENDA",
  //   btnTittleBlock: "ROOM BLOCK",
  //   href: "",
  //   onClick: MIagendaOpen,
  //   onClickLink: agenda,
  // },
  {
    id: 1,
    logo: Logo,
    state: Texas,
    classNameState: TexasImg,
    stateName: "Dallas, Texas",
    stateSubName: "Round Up 2026",
    when: " March 6th, 26 – March 7th, 26",
    time: " 7:00 PM",
    addressTitle1: "The Westin Dallas Park Central",
    addressTitle2: "12720 Merit Drive ,",
    address1: "Dallas Texas 75251",
    address2: "",
    btnTittle: "REGISTER",

    //VIEW AGENDA TEXT -------------------
    btnTittle2: "VIEW AGENDA",
    // -----------------------------------

    btnTittleBlock: "ROOM BLOCK",
    href: "https://accesscoordinatorbootcamp.com/register",
    hrefBlock:
      "https://www.marriott.com/event-reservations/reservation-link.mi?id=1755535778983&key=GRP&app=resvlink",
    hrefApple:
      "https://itunes.apple.com/app/apple-store/id716979741?pt=1944835&ct=&mt=8",
    hrefAndroid:
      "https://play.google.com/store/apps/details?id=com.whova.event&referrer=utm_source%3D%26utm_medium%3Dportal%26utm_content%3DEsX2yxkKymCeadWIc-Oxxr07g3veW39f1bzuZn72tLM=",
    AppleTitle: "DOWNLOAD ON APPLE",

    // This is the title for the download app button, you can change it to whatever you want
    AndroidTitle: "DOWNLOAD ON ANDROID",

    //VIEW AGENDA BUTTON ----------------
    onClick: DallasAgendaOpen,
    // -----------------------------------
    onClickLink: agenda,
  },
];

export default EventsData;
